import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { publicGet } from '@/lib/api/publicClient';
import { publicPaymentEndpoints } from '@/lib/api/endpoints';
import type { PaymentPageData } from '@/types/onlineBooking';

export const paymentPageKeys = {
  all: () => ['public', 'payment'] as const,
  detail: (paymentId: string) => [...paymentPageKeys.all(), paymentId] as const,
};

export function usePaymentPageData(
  paymentId: string,
  /** Poll while an inline (ACH) payment attempt is settling. */
  options?: {
    refetchInterval?: UseQueryOptions<PaymentPageData>['refetchInterval'];
  },
) {
  return useQuery<PaymentPageData>({
    queryKey: paymentPageKeys.detail(paymentId),
    queryFn: () => publicGet<PaymentPageData>(publicPaymentEndpoints.paymentPage(paymentId)),
    enabled: !!paymentId,
    staleTime: 60_000,
    refetchInterval: options?.refetchInterval ?? false,
  });
}
